import AdminReportClassCompare from 'views/AdminReportClassCompare/AdminReportClassCompare'

export default AdminReportClassCompare
